import {
  DELIVERY_ERROR,
  GET_DELIVERY,
  GET_DELIVERY_CONTACT,
  CREATE_DELIVERY_SUCCESS,
  CREATE_DELIVERY_FAILED,
  EDIT_DELIVERY_FAILED,
  CREATE_DELIVERY_PENDING,
  DELIVERY_RESET,
  EDIT_DELIVERY_SUCCESS,
} from "../constants/deliveryConstants";

const initialState = {
  delivery: null,
  loading: true,
};

export const requestDelivery = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_DELIVERY:
      return Object.assign({}, state, {
        delivery: action.payload,
        loading: false,
      });
    case DELIVERY_ERROR:
      return Object.assign({}, state, { error: action.payload });
    case DELIVERY_RESET: {
      return Object.assign({}, state, {
        delivery: null,
        loading: true,
      });
    }
    default:
      return state;
  }
};

export const requestContact = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_DELIVERY_CONTACT:
      return Object.assign({}, state, {
        delivery: action.payload,
        loading: false,
      });
    case DELIVERY_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export const postDelivery = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_DELIVERY_PENDING:
      return Object.assign({}, state, { isPending: true });
    case CREATE_DELIVERY_SUCCESS:
      return Object.assign({}, state, {
        delivery: action.payload,
        loading: false,
      });
    case CREATE_DELIVERY_FAILED:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};
export const editDelivery = (state = initialState, action = {}) => {
  switch (action.type) {
    case EDIT_DELIVERY_SUCCESS:
      return Object.assign({}, state, {
        delivery: action.payload,
      });
    case EDIT_DELIVERY_FAILED:
      return Object.assign({}, state, {
        error: action.payload,
      });
    default:
      return state;
  }
};
